export default "__VITE_ASSET__M6$WHN7t__"